import { render, staticRenderFns } from "./CollapseHeader.vue?vue&type=template&id=042f7a3a&"
import script from "./CollapseHeader.vue?vue&type=script&lang=js&"
export * from "./CollapseHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports